import React from 'react';

const Agents = () => {
    return (
        <div>
            <h2>Agents</h2>
            <p>This is the Agents page. Manage your team of agents here.</p>
        </div>
    );
};

export default Agents;
